module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-circle plus"
  }, [(_vm.index == 3 && _vm.total > 4) ? _c('span', [_vm._v("+" + _vm._s(_vm.total - 3))]) : (_vm.user.profileimg === 'default') ? _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": "https://firebasestorage.googleapis.com/v0/b/pei-exchange.appspot.com/o/profile-images%2Fdefaultimg1.jpg?alt=media&token=1704a992-1ea9-4c8d-a8c5-e4c59803155f"
    }
  }) : _c('img', {
    staticClass: "image-circle",
    attrs: {
      "src": _vm.user.profileimg
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2659e6db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/list/ProfilePicture.vue
// module id = 694
// module chunks = 1